module.exports = __webpack_public_path__ + "img/banner1.1ec407fe.jpg";